import t from "@/lang/lang";
import { PositionsBaseDataFieldsConfig } from "../position/components/positions-base-data-fields";
import { PositionKind } from "../position/types/position-kind";
import { OptionAvailability } from "../position/types/position-base-data";
import { wrhPricesUsed } from "./wrh-prices-used";

/**
 * wrhPositionsBaseDataFieldsConfig configures the
 * {@link PositionsBaseDataFields} of the WRH positions base data. WRH
 * positions belong to no group or area, so options are only offered
 * outside of any, see `WRHPositions.ValidateBaseData`,
 * backend/core/omni/domain/servicekindrules/wrh_positions.go.
 * A product's consumables are priced sub-positions.
 */
export const wrhPositionsBaseDataFieldsConfig: PositionsBaseDataFieldsConfig = {
  availabilities: [
    { value: OptionAvailability.ZeroGrouping, label: t("Übergreifend") },
  ],
  pricesUsed: wrhPricesUsed,
  subPositionKinds: [
    PositionKind.Default,
    PositionKind.Dynamic,
    PositionKind.Text,
  ],
};
